import axios from 'axios';

class FeatureAPI {
  static fetch(): Promise<string[]> {
    return new Promise((resolve, reject) => {
      axios.get<string[]>(`${window.API_URLS.features}`).then((response) => {
        resolve((response.data || []) as string[]);
      }).catch((e) => {
        reject(e);
      });
    });
  }
}

export default FeatureAPI;
